// "Your bank account" block of the CRM 2.0 Agreement KYC (M3-F3; rows M3.2, M3.39; DC-74 / DC-145).
// Same fields as today's Booking Form bank block (customerBankDetails). The account holder must be the
// primary applicant (checked again on the server). Used for Agreement-stage refunds and the Booking Form.
import React from "react";
import { MenuItem, TextField } from "@mui/material";
import css from "./Crm2Booking.module.css";

export const EMPTY_BANK = { accHolderName: "", accountNo: "", ifscCode: "", bankName: "", accType: "" };
const IFSC_RE = /^[A-Z]{4}0[A-Z0-9]{6}$/;

// field → message; empty object = fine
export function checkBank(bank, primary) {
	const e = {};
	if (!bank?.accHolderName) e.accHolderName = "Enter the account holder name";
	if (!/^\d{6,18}$/.test(String(bank?.accountNo || ""))) e.accountNo = "Enter a valid account number";
	if (!IFSC_RE.test(String(bank?.ifscCode || "").toUpperCase())) e.ifscCode = "Enter a valid IFSC (e.g. HDFC0001234)";
	if (!bank?.bankName) e.bankName = "Enter the bank name";
	if (!bank?.accType) e.accType = "Choose the account type";
	const words = (s) => String(s || "").toUpperCase().replace(/[^A-Z ]/g, " ").split(/\s+/).filter(Boolean);
	const have = new Set(words(bank?.accHolderName));
	const need = [...words(primary?.firstName), ...words(primary?.lastName)];
	if (bank?.accHolderName && need.length && !need.every((w) => have.has(w))) e.accHolderName = "The account holder must be the primary applicant";
	return e;
}

export default function Crm2BankBlock({ value, onChange, errors = {}, disabled }) {
	const set = (k) => (e) => onChange({ ...value, [k]: k === "ifscCode" ? e.target.value.toUpperCase() : k === "accountNo" ? e.target.value.replace(/\D/g, "") : e.target.value });
	const field = (k, label, extra = {}) => (
		<TextField
			key={k}
			label={label}
			value={value?.[k] || ""}
			onChange={set(k)}
			error={!!errors[k]}
			helperText={errors[k] || ""}
			disabled={disabled}
			size="small"
			fullWidth
			{...extra}
		/>
	);
	return (
		<div className={css.bankBlock}>
			<div className={css.bankHead}>
				<b>Your bank account</b>
				<span>For refunds and your Booking Form. The account holder must be the primary applicant.</span>
			</div>
			<div className={css.bankGrid}>
				{field("accHolderName", "Account holder name")}
				{field("accountNo", "Account number", { inputProps: { inputMode: "numeric", maxLength: 18 } })}
				{field("ifscCode", "IFSC", { inputProps: { maxLength: 11 } })}
				{field("bankName", "Bank name")}
				{field("accType", "Account type", {
					select: true,
					children: ["Savings", "Current", "NRE", "NRO"].map((t) => (
						<MenuItem key={t} value={t}>
							{t}
						</MenuItem>
					)),
				})}
			</div>
		</div>
	);
}
